<template>
    <v-dialog v-model="shows" max-width="560" persistent>
        <template v-slot:activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-if="isLoaded" height="100%">
            <v-card-title>
                <template v-if="isCreate">작가 생성</template>
                <template v-else>작가 상세</template>
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="pa-0" style="max-height: calc(90vh - 120px); overflow-y: auto">
                <v-row no-gutters>
                    <v-col>
                        <v-card-subtitle>기본 정보</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col class="mr-3">
                                    <v-text-field label="국가(국문)" v-model="inputs.country.ko" v-bind="attrs_input" />
                                </v-col>
                                <v-col>
                                    <v-text-field label="국가(영문)" v-model="inputs.country.en" v-bind="attrs_input" />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col class="mr-3">
                                    <v-text-field label="이름(국문)" v-model="inputs.name.ko" v-bind="attrs_input" class="my-3" />
                                </v-col>
                                <v-col>
                                    <v-text-field label="이름(영문)" v-model="inputs.name.en" v-bind="attrs_input" class="my-3" />
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col class="mr-3">
                                    <v-text-field label="생년월일" type="date" v-model="inputs.bornAt" v-bind="attrs_input" clearable />
                                </v-col>
                                <v-col>
                                    <v-text-field label="생몰월일" type="date" v-model="inputs.diedAt" v-bind="attrs_input" clearable />
                                </v-col>
                            </v-row>
                            <v-textarea label="설명" v-model="inputs.content" v-bind="attrs_input" auto-grow class="mt-3" />
                        </v-card-text>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn large color="primary" @click="save"> 저장하기 </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { attrs_input } from "@/assets/variables";

const initAuthor = () => ({
    name: {
        ko: null,
        en: null,
    },
    country: {
        ko: null,
        en: null,
    },
    content: null,
    bornAt: null,
    diedAt: null,
});

export default {
    props: {
        value: { type: Object },
    },
    data: () => ({
        shows: false,
        isLoaded: false,
        inputs: {},

        attrs_input,
    }),
    computed: {
        _author() {
            return this.value?._id;
        },
        isCreate() {
            return !this._author;
        },
    },
    methods: {
        async init() {
            this.isLoaded = false;
            if (this.isCreate) {
                this.inputs = { ...initAuthor() };
            } else {
                const { author } = await api.console.auction.authors.get({ _id: this._author });

                author.bornAt = author?.bornAt?.toDate?.() || author.bornAt;
                author.diedAt = author?.diedAt?.toDate?.() || author.diedAt;
                this.inputs = author;
            }
            this.isLoaded = true;
        },

        validate() {},

        async save() {
            try {
                this.validate();

                const { ...inputs } = this.inputs;

                // Document POST / PUT
                let author;
                if (this.isCreate) [author] = [(await api.console.auction.authors.post(inputs))?.author];
                else [author] = [(await api.console.auction.authors.put(inputs))?.author];

                alert("저장되었습니다");
                this.$emit("input", author);
                this.shows = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>
